import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function HeroAirportTransfer() {
  return <section id="hero-airport-transfer" className="relative w-full h-screen min-h-[600px] flex items-center justify-center overflow-hidden bg-background">
      {}
      <div className="absolute inset-0 z-0">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/lax_terminal_dusk.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/lax_terminal_dusk.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/lax_terminal_dusk.png-wvc-sizes" alt="LAX Terminal at dusk" className="w-full h-full object-cover object-center" loading="eager" decoding="async" />
        <div className="absolute inset-0 bg-black/40" aria-hidden="true" />
      </div>

      {}
      <div className="relative z-10 flex flex-col items-center text-center px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto animate-reveal">
        <h1 className="font-display text-4xl sm:text-5xl md:text-[48px] font-bold text-white leading-tight tracking-tight mb-6">
          Seamless LAX Arrivals & Departures
        </h1>
        <p className="font-sans text-lg sm:text-[20px] text-white/90 max-w-2xl mb-10 leading-relaxed">
          Experience uncompromising punctuality and premium comfort with our dedicated Los Angeles International Airport transfer service.
        </p>
        <Button asChild size="lg" className="btn-primary h-auto py-4 px-10 text-lg rounded-md">
          <Link to="/ReservationsPage">
            Book Your Transfer
          </Link>
        </Button>
      </div>
    </section>;
}